import React from "react";
import {useTranslation} from "react-i18next";
//local
import {availableInArray} from "constants/select.consts";
import CustomRadioSwitch from "components/CustomRadioSwitch";
import MultipleSelect from "components/selects/MultipleSelect";

export const FirstSetupSelections = ({onChange, params}) => {
  const {t} = useTranslation();

  return (
    <div className="first-setup_selection__wrapper">
      <div className="first-setup_selection__item-wrap mr-2">
        <MultipleSelect
          title={"availableIn"}
          value={params.availableIn}
          list={availableInArray}
          small
          needSearch
          color="green"
          onChange={(value) => onChange("availableIn", value)}
          customSuffixSelectedRowcontent={
            !!params.availableIn?.length ? (
              <CustomRadioSwitch
                checked={!!params.availableIn?.length ? params.localSuppliers : false}
                uppercase
                label={t("FIRST_SETUP_SELECT_LOCAL_SUPPLIERS")}
                small
                addWrapperClass="ml-2 mba"
                wrapperStyle={{marginTop: "6px"}}
                informationText="FIRST_SETUP_SELECT_LOCAL_SUPPLIERS_TOOLTIP"
                isActive={() => onChange("localSuppliers", !params.localSuppliers)}
              />
            ) : null
          }
        />
      </div>
    </div>
  );
};
